
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useForm } from "react-hook-form";
import { MuniSpinner2 } from "../../../components";
import { notificarActa } from "../../../handlers/notificadores.handler";
import { useContext, useEffect, useState } from "react";
import { getNotificarMismoTitular } from "../../../services";
import { UserContext } from "../../../context";
import BadgeNumero from "../../../components/BadgeNumero";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useNotificadoresStore } from "../../../store/notificadoresStore";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { schemaFormularioNotificar } from "../../../schema/validacion-notificar";
// import { getMotivos, notificar, reportarNoNotificada } from "../../../services";


const ModalNotificar = ({ titleModal, row, setRefetch, cambiarActa }) => {
    const { actasRelacionadas } = useNotificadoresStore();
    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { actions } = useContext(UserContext);
    const [actasANotificar, setActasANotificar] = useState();

    const { register, handleSubmit } = useForm({
        defaultValues: {
            array_ids: actasRelacionadas?.map((afm) => afm.id),
            accion: "notificar",
        }
    });

    const onSubmit = async (data) => {
        notificarActa(data, setRefetch)
    }

    const getActasNot = async () => {
        setActasANotificar(await getNotificarMismoTitular({ plate: row?.plate, documento_titular: row?.documento_titular, user_id_notificador: actions?.user().usuarioID }))
    }

    useEffect(() => {

        // getActasNot()

    }, [])


    return (
        <>
            <Modal
                show={modals.includes('notificar')}
                onHide={() => handlerModal({ modal: false, modalName: "notificar" })}
                size="smd"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{
                    backgroundColor: (modals.length > 1 && modals[0] === 'acta_detalle') || (modals.length > 1) ? 'rgba(0,0,0,0.4)' : '',
                }}
            >
                <div className="position-relative">
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titleModal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form
                            className="w-100 position-relative"
                            onSubmit={handleSubmit(onSubmit)}
                        >
                            {
                                loads.includes('load_notificar') &&
                                <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)", zIndex: "999" }}>
                                    <MuniSpinner2 />
                                </div>
                            }

                            <Alert variant="success">
                                <div className="bg-white d-flex flex-column align-items-center gap-2 p-4 border rounded shadow-lg w-100">
                                    <p className="fw-bold text-center">Actas a notificar mismo titular</p>
                                    <div className="d-flex justify-content-center flex-wrap gap-2">
                                        {
                                            actasRelacionadas?.map(acta => {
                                                return (
                                                    <div key={acta?.id}>
                                                        <BadgeNumero estado_id={8} numero={acta?.numero_acta} size={'md'} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <span className="text-center">Puedes notificar actas</span> */}
                                    <div className="d-flex gap-2 justify-content-center align-items-center ">
                                        {
                                            actasANotificar?.map((acta) => {
                                                return (
                                                    <div key={acta?.id}>
                                                        <BadgeNumero estado_id={8} numero={acta?.numero_acta} size={'md'} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Alert>

                            {/* <Form.Group className="col-12">
                                <Form.Label>Observación</Form.Label>
                                <Form.Control {...register("observacion")} as={"textarea"} style={{ resize: "none" }} />
                            </Form.Group> */}
                            <hr />
                            <div className="d-flex w-100 justify-content-center ">
                                <Button type="submit" size="md" variant="success">
                                    <TaskAltIcon /> Notificar
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </div>
            </Modal>


        </>
    );
}
export default ModalNotificar;